export default __webpack_public_path__ + "static/media/logo_espol_blanco_mr.29b9d02d.svg";